'use client';

import { AppToastContainer } from '@/components/common';
import { AudioRefProvider } from '@/lib/contexts/AudioRefContext';
import { QueryDevtools } from '@/lib/query/devtools';
import { QueryProvider } from '@/lib/query/provider';

/**
 * 클라이언트 Provider 래퍼
 *
 * 루트 레이아웃은 Server Component여야 CSS가 제대로 로드되므로,
 * 클라이언트 컴포넌트가 필요한 Provider들을 여기에 분리합니다.
 *
 * 상태 관리 구조:
 * - Server State: TanStack Query (QueryProvider)
 * - UI State: Zustand Stores (Provider 불필요)
 * - Audio Ref: AudioRefContext (HTMLAudioElement ref 관리)
 */
export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryProvider>
      <AudioRefProvider>
        {children}
        <AppToastContainer />
        <QueryDevtools />
      </AudioRefProvider>
    </QueryProvider>
  );
}
